import React from 'react'
import PropTypes from 'prop-types'
import './style.css'
import PatientBox from './PatientBox'
import Allergies from './Allergies'
import { patientsDatabase } from '../../../index'
import Notes from './Notes'
import Graphics from './Graphics'
import Loading from '../../common/Loading/Loading'
import Medication from './Medication/Medication'

export default class Home extends React.PureComponent {
  componentWillMount () {
    this.props.hidePatientIndicator(true)
    if (this.props.auth.isAuthenticated()) {
      if (this.props.match.params.patientId) {
        if (!this.props.patientKey) {
          this.props.patientChangeHandle(this.props.match.params.patientId)
        }
      } else {
        this.props.history.replace('/patients')
      }
    }
  }

  handleAllergySubmit (allergy) {
    window.myLogger.info(JSON.stringify({
      message: 'Allergy Submitted',
      allergy: allergy,
      patientKey: this.props.patientKey
    }))
    const consultationsRef = patientsDatabase.child(this.props.patientKey).child('data').child('allergies')
    consultationsRef.push(allergy)
  }

  handleAllergyChange (key, allergy) {
    window.myLogger.info(JSON.stringify({
      message: 'Allergy Changed',
      allergyKey: key,
      allergy: allergy,
      patientKey: this.props.patientKey
    }))
    const consultationsRef = patientsDatabase.child(this.props.patientKey).child('data').child('allergies').child(key)
    consultationsRef.set(allergy)
  }

  handleMedicationSubmit (medication) {
    window.myLogger.info(JSON.stringify({
      message: 'Medication Submitted',
      medication: medication,
      patientKey: this.props.patientKey
    }))
    const consultationsRef = patientsDatabase.child(this.props.patientKey).child('data').child('medication')
    consultationsRef.push(medication)
  }

  handleMedicationChange (key, medication) {
    window.myLogger.info(JSON.stringify({
      message: 'Medication Changed',
      medicationKey: key,
      medication: medication,
      patientKey: this.props.patientKey
    }))
    const consultationsRef = patientsDatabase.child(this.props.patientKey).child('data').child('medication').child(key)
    consultationsRef.set(medication)
  }

  handleNoteSubmit (object) {
    window.myLogger.info(JSON.stringify({message: 'Note Submitted', note: object, patientKey: this.props.patientKey}))
    const consultationsRef = patientsDatabase.child(this.props.patientKey).child('data').child('notes')
    consultationsRef.push(object)
  }

  handleNoteChange (key, object) {
    window.myLogger.info(JSON.stringify({
      message: 'Note Changed',
      note: object,
      noteKey: key,
      patientKey: this.props.patientKey
    }))
    const consultationsRef = patientsDatabase.child(this.props.patientKey).child('data').child('notes').child(key)
    consultationsRef.set(object)
  }

  render () {
    if (this.props.patient) {
      window.myLogger.info(JSON.stringify({message: 'Home Component Rendered', patient: this.props.patientKey}))
      return <div>
        <div className='columns'>
          <div>
            <PatientBox patient={this.props.patient} />
          </div>
          <div>
            <Allergies
              config={this.props.configuration['allergyInsertion']}
              doctorName={'Ricardo'}
              handleAllergyChange={this.handleAllergyChange.bind(this)}
              handleAllergySubmit={this.handleAllergySubmit.bind(this)}
              patientBirthDate={this.props.patient.birthDate}
              allergies={this.props.patient.data ? this.props.patient.data.allergies : null} />
          </div>
          <div>
            <Medication
              config={this.props.configuration['medicationInsertion']}
              doctorName={'Ricardo'}
              handleMedicationChange={this.handleMedicationChange.bind(this)}
              handleMedicationSubmit={this.handleMedicationSubmit.bind(this)}
              patientBirthDate={this.props.patient.birthDate}
              medication={this.props.patient.data ? this.props.patient.data.medication : null} />
          </div>
          <div>
            <Graphics patientData={this.props.patient.data} />
          </div>
          <div>
            <Notes
              config={this.props.configuration['noteInsertion']}
              doctorName={'Ricardo'}
              handleChange={this.handleNoteChange.bind(this)}
              handleSubmit={this.handleNoteSubmit.bind(this)}
              patientBirthDate={this.props.patient.birthDate}
              savedObjects={this.props.patient.data ? this.props.patient.data.notes : null} />
          </div>
        </div>
      </div>
    } else {
      return <Loading />
    }
  }
}

Home.propTypes = {
  patient: PropTypes.object,
  patientKey: PropTypes.string,
  auth: PropTypes.object.isRequired,
  patientChangeHandle: PropTypes.func.isRequired,
  hidePatientIndicator: PropTypes.func.isRequired,
  configuration: PropTypes.object.isRequired
}



// WEBPACK FOOTER //
// ./src/components/general/Home/Home.js